const listeners = new Set();
let timerId = null;
let visibilityBound = false;

function tick() {
  const now = Date.now();
  listeners.forEach((listener) => listener(now));
}

function stopTimer() {
  if (timerId == null) return;
  clearInterval(timerId);
  timerId = null;
}

function startTimer() {
  if (timerId != null || listeners.size === 0) return;
  if (typeof document !== "undefined" && document.visibilityState === "hidden") {
    return;
  }
  timerId = setInterval(tick, 1000);
}

function onVisibilityChange() {
  if (document.visibilityState === "hidden") {
    stopTimer();
    return;
  }
  tick();
  startTimer();
}

function bindVisibility() {
  if (visibilityBound || typeof document === "undefined") return;
  document.addEventListener("visibilitychange", onVisibilityChange);
  visibilityBound = true;
}

function unbindVisibility() {
  if (!visibilityBound || typeof document === "undefined") return;
  document.removeEventListener("visibilitychange", onVisibilityChange);
  visibilityBound = false;
}

export function subscribeWaitingClock(listener) {
  listeners.add(listener);
  bindVisibility();
  listener(Date.now());
  startTimer();
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) {
      stopTimer();
      unbindVisibility();
    }
  };
}

export function waitingClockSubscriberCount() {
  return listeners.size;
}

export function waitingClockIsRunning() {
  return timerId != null;
}

export function formatWaitingDuration(createdAt, now = Date.now()) {
  const start = new Date(createdAt).getTime();
  if (!createdAt || Number.isNaN(start)) return "—";
  const elapsedMs = now - start;
  if (elapsedMs < 0) return "—";
  const totalSeconds = Math.floor(elapsedMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
